export default __webpack_public_path__ + "a87fba56c0618e4251a04b48816f693a.svg";